@if (!isLoading) {
  <div class="component-content">
    <app-tab-menu
      class="align-self-stretch"
      [tabs]="tabs"
      [activeTab]="activeTab"
      (tabChange)="onTabChange($event)"></app-tab-menu>
    @if (activeTab === 'details') {
      <app-seminar-details
        [seminarDateSeries]="seminarDateSeries"
        [isAdmin]="true"
        [listView]="true">
      </app-seminar-details>
    }
    @if (activeTab === 'attendees') {
      <app-seminar-attendees
        [seminarDateSeries]="seminarDateSeries"></app-seminar-attendees>
    }
  </div>
} @else {
  <div class="loading-wrapper">
    <mat-progress-spinner color="primary" mode="indeterminate" diameter="32">
    </mat-progress-spinner>
  </div>
}
